<template>
    <div class="orgDetail">
        <div class="left-box">
            <LeftPage :active="3"/>
        </div>
        <div class="right-box flex flex-direction">
            <div class="table-box flex-sub">
                <div class="title">
                    <div class="icon-box">
                        <i class="iconfont icon-xuanchuanhuodong-copy"></i>
                    </div>
                    <b>宣传信息管理</b>
                </div>
                <div class="tab margin-top-sm">
                    <span v-for="item in promotionalOptions"
                          :key="item.value"
                          :class="{active:item.value == active}"
                          class="tab-item" @click="active = item.value">{{ item.label }}</span>
                </div>
                <publish v-if="active == 0"></publish>
                <material v-else></material>
            </div>
        </div>
    </div>
</template>
<script>
import LeftPage from "@/views/admin/pages/info/common/leftPage";
import Publish from "@/views/admin/pages/info/promotional/common/publish";
import Material from "@/views/admin/pages/info/promotional/common/material";

export default {
    name: "promotional",
    data() {
        return {
            active: 0,
            promotionalOptions: [
                {
                    label: "已发布的",
                    value: 0
                },
                {
                    label: "宣传信息管理",
                    value: 1
                },
            ],
        }
    },
    components: {Material, Publish, LeftPage},
    computed: {

    },
    created() {
        this.$emit("setActive", {
            headActive: 5
        })
    },
    methods: {

    },
    watch: {},
    filters: {

    }
}
</script>

<style lang="scss" scoped>
.red {
    color: #f61919;
}
.orgDetail {
    width: 100%;
    min-height: calc(100vh - (173px + 159px));
    background: #f3f5f7;
    padding: 20px;
    display: flex;
    justify-content: flex-start;

    .title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-bottom: 25px;
        border-bottom: 1px solid #e3e7f0;
        b {
            font-size: 22px;
            color: #16181d;
            font-weight: bold;
            margin-left: 10px;
        }
        .icon-box {
            width: 30px;
            height: 30px;
            background-image: linear-gradient(-30deg,
                #3579fb 0%,
                #44a3ff 100%);
            box-shadow: 0px 10px 10px 0px
            rgba(50, 150, 255, 0.3);
            border-radius: 10px;
            text-align: center;
            line-height: 30px;

            i {
                font-size: 20px;
                color: #ffffff;
            }
        }
    }
}
.right-box {
    flex: 1;
    margin-left: 25px;
    width: 100%;
      min-height: calc(100vh - (173px + 159px));
    background: #f3f5f7;

    .table-box {
        width: 100%;
        background-image: linear-gradient(0deg,
            #ffffff 84%,
            #edf6ff 100%);
        padding: 30px 20px 0;
        border-radius: 10px;
        min-height: 500px;

        .tab {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: solid 2px #e3e7f0;

            span {
                width: max-content;
                margin-left: 45px;
                height: 60px;
                line-height: 60px;
                font-size: 18px;
                color: #63686e;
                margin-right: 20px;
                cursor: pointer;

                &.active {
                    color: #2791ff;
                    font-weight: bold;
                    border-radius: 2px;
                    border-bottom: solid 4px #2791ff;
                }
            }
        }

    }
}
</style>


